import {
  PluginSetupData,
  PluginResponse,
  PluginData,
  PluginInitResponse,
} from './types';
import BaseAPI from '../BaseAPI';
import { IVFSResponse } from '../types';

/**
 * Plugin API
 * Handles plugin-related operations
 */
class PluginAPI extends BaseAPI {
  /**
   * Initialize a plugin
   * @param key - Plugin key
   * @returns Promise with plugin initialization response
   */
  async initPlugin(
    key: string
  ): Promise<IVFSResponse<PluginResponse<PluginInitResponse>>> {
    return this.wrapResponse<PluginResponse<PluginInitResponse>>({
      promise: this.apiInstance.get(`/v2/plugin/init/${key}`),
      errorMessage: 'Failed to initialize plugin',
    });
  }

  /**
   * Get plugin configuration
   * @returns Promise with plugin configuration
   */
  async getPlugin(): Promise<IVFSResponse<PluginResponse<PluginData>>> {
    return this.wrapResponse<PluginResponse<PluginData>>({
      promise: this.apiInstance.get('/v2/plugin/setup'),
      errorMessage: 'Failed to get plugin configuration',
    });
  }

  /**
   * Set up a plugin
   * @param data - Plugin setup data containing website URL
   * @returns Promise with plugin setup response
   */
  async setupPlugin(
    data: PluginSetupData
  ): Promise<IVFSResponse<PluginResponse<PluginData>>> {
    return this.wrapResponse<PluginResponse<PluginData>>({
      promise: this.apiInstance.post('/v2/plugin/setup', data),
      errorMessage: 'Failed to set up plugin',
    });
  }
}

export default PluginAPI;
